import React from 'react';
import {AppHelmet, AppWrapper, baseUrl, baseRealtyUrl, baseRealEstateUrl, getUrlWithUtmQueryString } from '@capcenter/shared';
import {
  GlobalIcons,
  ImageCapCenterHQ,
  ImageSmores2,
  ImageSmores,
  ImageGlenAllenVA,
  ImageGlenAllenVA2,
  ImageGlenAllenVAPieDay,
  ImageGlenAllenVAPieDay2,
  ImageGlenAllenVAPieDay3,
  ImageGlenAllenVAPieDay4,
  ImageGlenAllenVAHalloweenTeam,
  ImageGlenAllenVAHalloween,
  ImageRichmondRaceway
} from '@capcenter/shared-legacy';
import {ImageGlenAllenOffice} from '@capcenter/shared-service-map';
import './Locations.scss';
import getElasticSearchListings from '../Utilities/GetElasticSearchListings';
import buildListingURL from '../Utilities/BuildURLString';


GlobalIcons();

function State(
  props: any
) {
  const [renderedHtmlListings, setRenderedHtmlListings] = React.useState<Array<any>>([]);
  const [initialized, setInitialized] = React.useState<boolean>(false);
  let htmlListings: any = [];

  async function getListings(state: string) {
    const response = await getElasticSearchListings({isRealty: props.custom.isRealty, state: state});
    return response.json();
  };

  function buildListingLinkText(listingSource: any) {
    const addressLineOne = listingSource?.UnparsedAddress?.replace(/#/g, 'Unit ');
    const city = listingSource?.City;
    const stateOrProvince = listingSource?.StateOrProvince;
    const postalCode = listingSource?.PostalCode;

    let propertyAddress = `${addressLineOne}, ${city}, ${stateOrProvince} ${postalCode}`;

    if (listingSource?.isCapcenterListing) {
      propertyAddress += " (CapCenter Listing)";
    }

    return propertyAddress;
  }

  async function renderListings() {
    const listingResponse = await getListings(props.custom.state);
    const listings = listingResponse.hits.hits;

    for (let i = 0; i < listings.length; i++) {

      let listItem =
        <li key={i}>
          <a href={getUrlWithUtmQueryString(buildListingURL(listings[i]._source))} target='_blank' rel='noreferrer noopener'>
            {buildListingLinkText(listings[i]._source)}
          </a>
        </li>;

      htmlListings.push(listItem);
    }

    setRenderedHtmlListings(htmlListings);
  }

  if (!initialized) {
    setInitialized(true);
    renderListings();
  }

  return (
    <React.Fragment>
      {(
        <AppWrapper>
          <>
            <AppHelmet
              custom={props.custom}
            />

            <div role="document">
              <main className={"locations container pb-4 " + (props.custom.code)} role="main">
                <article>
                  <header>
                    <div className={(props.custom.code)}>
                      <div className={"col-12" + (props.custom.code)}>
                        <h1>{props.custom.title}</h1>
                        <p>{props.custom.description}</p>
                      </div>
                    </div>
                  </header>

                  <section className={(props.custom.code)}>
                    <div className="row">
                      <div className="col-12 col-md-4">
                        <h3>Address</h3>
                        <p>
                          <a href="https://goo.gl/maps/sjSk8U2zC4PPSckL8" title="CapCenter branch office in Cary, NC near Raleigh and Durham North Carolina" target="_blank" rel="noreferrer noopener">
                            2500 Regency Parkway
                            <br />
                            Cary, NC 27518
                          </a>
                        </p>
                        <p>
                          <a href="https://goo.gl/maps/bHnS79zZybJr2UCy5" title="CapCenter branch office in Charlotte, NC" target="_blank" rel="noreferrer noopener">
                            15720 Brixham Hill Ave #500
                            <br />
                            Charlotte, NC 28277
                          </a>
                        </p>
                      </div>
                      <div className="col-12 col-md-4">
                        <h3>Contact</h3>
                        <p>
                          <a href="/contact/best-mortgage-cary-nc">Cary, NC</a><br />
                          <a href="tel:9196366166">
                            +1 (919) 636-6166
                          </a>
                        </p>
                        <p>
                          <a href="/contact/best-mortgage-charlotte-nc">Charlotte, NC</a><br/>
                          <a href="tel:7048215599">
                            +1 (704) 821-5599
                          </a>
                        </p>
                        <p>
                          <a href="mailto:customerservice@capcenter.com">
                            customerservice@capcenter.com
                          </a>
                        </p>
                      </div>
                      <div className="col-12 col-md-4">
                        <h3>Hours</h3>
                        <p>
                          By appointment only
                        </p>
                        <p>
                          By appointment only
                        </p>
                      </div>
                    </div>
                  </section>

                  <section className={(props.custom.code)}>
                    <div className="row">
                      <div className="col-12">
                        <h2>About CapCenter Mortgage in {props.custom.stateLongName}</h2>
                      </div>

                      <div className="col-12 col-md-8">
                        <p>
                          North Carolina is a state in the Eastern and Southeastern regions of the United States with a population of 10,439,388 in 2020. North Carolina is one of the best places to live in the United States of America because of its beaches and mild weather.
                          The capital of North Carolina is Raleigh.
                          CapCenter is proud to serve North Carolina and its residents to make home ownership more affordable.
                        </p>

                        <p>
                          North Carolina is one of the best places to live and work because of its proximity to shops, restaurants, parks, and businesses. CapCenter supports
                          &nbsp;<a href="/contact/best-mortgage-charlotte-nc">Charlotte</a>,&nbsp;
                          &nbsp;<a href="/contact/best-mortgage-cary-nc">Raleigh</a>,&nbsp;
                          &nbsp;<a href="/contact/best-mortgage-cary-nc">Durham</a>,&nbsp;
                          &nbsp;<a href="/contact/best-mortgage-cary-nc">Cary</a>,&nbsp;
                          Asheville, Greensboro, Wilmington, Fayetteville, Boone, Winston-Salem, Chapel Hill,
                          Concord, High Point, Rocky Mount, Mooresville, Gastonia, New Bern, Hendersonville, Goldsboro, Carolina Beach, Statesville, Kinston,
                          Lumberton, Apex, Waynesville, Mount Airy, Huntersville, Morganton, Elizabeth City, Asheboro, Morrisville, Kernersville, Fort Bragg,
                          Mebane, Lincolnton, Brevard, Fuquay-Varina, Pinehurst, Morehead City, Kannapolis, Blowing Rock, Southport, Roanoke Rapids, Cornelius,
                          Holly Springs, Bryson City, Wrightsville Beach, Laurinburg, Waxhax, Forest City, Southern Pines,
                          and more.
                        </p>

                        <p>
                          &nbsp;See homes in <a href={`${baseRealEstateUrl}/homes/location/city/durham-nc`} target="_blank" rel="noreferrer noopener">Durham, NC</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/greensboro-nc`} target="_blank" rel="noreferrer noopener">Greensboro, NC</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/greenville-nc`} target="_blank" rel="noreferrer noopener">Greenville, NC</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/charlotte-nc`} target="_blank" rel="noreferrer noopener">Charlotte, NC</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/wilmington-nc`} target="_blank" rel="noreferrer noopener">Wilmington, NC</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/asheville-nc`} target="_blank" rel="noreferrer noopener">Asheville, NC</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/fayetteville-nc`} target="_blank" rel="noreferrer noopener">Fayetteville, NC</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/rocky-mount-nc`} target="_blank" rel="noreferrer noopener">Rocky Mount, NC</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/boone-nc`} target="_blank" rel="noreferrer noopener">Boone, NC</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/winston-salem-nc`} target="_blank" rel="noreferrer noopener">Winston-Salem, NC</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/chapel-hill-nc`} target="_blank" rel="noreferrer noopener">Chapel Hill, NC</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/millbrook-nc`} target="_blank" rel="noreferrer noopener">Millbrook, NC</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/garner-nc`} target="_blank" rel="noreferrer noopener">Garner, NC</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/morrisville-nc`} target="_blank" rel="noreferrer noopener">Morrisville, NC</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/wilsonville-nc`} target="_blank" rel="noreferrer noopener">Wilsonville, NC</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/cary-nc`} target="_blank" rel="noreferrer noopener">Cary, NC</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/carolina-beach-nc`} target="_blank" rel="noreferrer noopener">Carolina Beach, NC</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/concord-nc`} target="_blank" rel="noreferrer noopener">Concord, NC</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/gastonia-nc`} target="_blank" rel="noreferrer noopener">Gastonia, NC</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/high-point-nc`} target="_blank" rel="noreferrer noopener">High Point, NC</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/mooresville-nc`} target="_blank" rel="noreferrer noopener">Mooresville, NC</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/new-bern-nc`} target="_blank" rel="noreferrer noopener">New Bern, NC</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/statesville-nc`} target="_blank" rel="noreferrer noopener">Statesville, NC</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/lumberton-nc`} target="_blank" rel="noreferrer noopener">Lumberton, NC</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/asheboro-nc`} target="_blank" rel="noreferrer noopener">Asheboro, NC</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/raleigh-nc`} target="_blank" rel="noreferrer noopener">Raleigh, NC</a>,
                          <a href={`${baseRealEstateUrl}/homes/location/city/morrisville-nc`} target="_blank" rel="noreferrer noopener">Morrisville, NC</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/morganton-nc`} target="_blank" rel="noreferrer noopener">Morganton, NC</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/pinehurst-nc`} target="_blank" rel="noreferrer noopener">Pinehurst, NC</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/oak-island-nc`} target="_blank" rel="noreferrer noopener">Oak Island, NC</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/mebane-nc`} target="_blank" rel="noreferrer noopener">Mebane, NC</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/mcleansville-nc`} target="_blank" rel="noreferrer noopener">McLeansville, NC</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/guilford-hills-nc`} target="_blank" rel="noreferrer noopener">Guilford Hills, NC</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/college-hill-nc`} target="_blank" rel="noreferrer noopener">College Hill, NC</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/oak-ridge-nc`} target="_blank" rel="noreferrer noopener">Oak Ridge, NC</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/colfax-nc`} target="_blank" rel="noreferrer noopener">Colfax, NC</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/sedalia-nc`} target="_blank" rel="noreferrer noopener">Sedalia, NC</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/pleasant-garden-nc`} target="_blank" rel="noreferrer noopener">Pleasant Garden, NC</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/jamestown-nc`} target="_blank" rel="noreferrer noopener">Jamestown, NC</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/pleasant-garden-nc`} target="_blank" rel="noreferrer noopener">High Point, NC</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/archdale-nc`} target="_blank" rel="noreferrer noopener">Archdale, NC</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/horneytown-nc`} target="_blank" rel="noreferrer noopener">Horneytown, NC</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/kernersville-nc`} target="_blank" rel="noreferrer noopener">Kernersville, NC</a>.&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/wilkesboro-nc`} target="_blank" rel="noreferrer noopener">Wilkesboro, NC</a>.&nbsp;
                        </p>

                        <p>
                          {"Our mortgage professionals (licensed loan officers and home loan consultants) in " + props.custom.stateLongName + " are mortgage experts trained to guide you through the complicated loan underwriting process so you can close on time with Zero hassles. CapCenter offers conventional, HomeReady®, Home Possible, Jumbo, VA, FHA, and adjustable rate mortgage loan products."}
                        </p>

                        <p>
                          CapCenter specializes in no-fee and low-fee mortgages with low interest rates.
                          We may initially seem like we don't offer the best rates in the market, but many lenders charge additional fees for lower interest rates in the form of points and lender and non-lender closing costs. If you're looking for the lowest rate, try applying expected closing costs to pay down discount points with CapCenter. In an apples to apples comparison, <strong>we offer some of the best rates in the market and do not simply add closing costs into the loan balance</strong>. We are always striving to offer the best overall package for each of our clients' unique needs.
                          We encourage borrowers to not only look at interest rates and APR but also non-lender fees and terms when comparing loan estimates.
                          CapCenter helps borrowers get around closing costs by eliminating fees for borrowers for many popular home loan products.
                          Many of our most popular home loan products have <strong>no closing costs</strong> or <strong>zero closing costs</strong> mortgages, which are often the best mortgage options for <strong>first-time home buyers</strong> and for anyone that may sell or refinance before the loan term (commonly 30 years) because these options allow for more funds to be allocated to the down payment and these options also have less sunk costs associated with paying off the loan on sale of the property or refinancing the loan if interest rates drop.
                          Some of our products, such as the VA home loan for veterans, have <strong>zero down payment</strong> options for certain borrowers and conditions, such as borrowers with service-connected disabilities and appraisal value.
                          Another set of products, such as <a href="https://faq.capcenter.com/article/74-does-capcenter-offer-homeready-and-home-possible-products" target="_blank" rel="noreferrer noopener">HomeReady® and Home Possible</a>, have <strong>low down payment</strong> options for certain borrowers and conditions, such as first-time home buyers and income limits.
                          Our loan consultants can guide you through our loan products to find the best fit loan for your specific situation before and after you apply. We're dedicated to provide you fast and reliable services with our refined operational procedures. It'll feel like we're waiving closing costs, and the most frequently asked question after receiving a free quote is, "what's the catch?" That's our secret sauce, but we assure you that there is no catch and 95% of our past clients would recommend our services to friends and family.
                          In fact, we encourage you to shop around and compare loan estimates (it helps to compare rates, points, terms, mortgage insurance, lender closing costs, and non-lender closing costs as well) and any realty credits. Once we've gain your trust, we're here to help you purchase all your future homes, saving you time and money, over and over again.
                        </p>

                        <p>
                          {props.custom.isRealty ?
                            (<><p><a href={getUrlWithUtmQueryString(`${baseRealtyUrl}/find-best-local-realtor`)} className={'d-flex btn-primary btn-sm'}>Find our best REALTORS® near {props.custom.stateLongName}</a></p><p><a href={getUrlWithUtmQueryString(`${baseRealtyUrl}/forms/request-realty`)} className={'d-flex btn-primary btn-sm'}>Schedule a consultation with a top-rated REALTOR® near {props.custom.stateLongName}</a></p></>) : ""}
                          {props.custom.isMortgage ?
                            (<a href={getUrlWithUtmQueryString(`${baseUrl}/apply-now/`)} className={'d-flex btn-primary btn-sm'}>Apply now for a mortgage in {props.custom.stateLongName}</a>) : ""}
                        </p>

                        <p>
                          <a href={getUrlWithUtmQueryString(`${baseUrl}/mortgage-rates/north-carolina`)} className={'d-flex btn-primary btn-sm'}>View our best mortgage interest rates today in {props.custom.stateLongName}</a>
                        </p>

                        <p>
                          <a href={getUrlWithUtmQueryString(`${baseUrl}/mortgage-calculator/purchase`)} className={'d-flex btn-primary btn-sm'}>Get a free, anonymous quote calculated to compare mortgage rates and closing costs in {props.custom.stateLongName}</a>
                        </p>

                        <p>&nbsp;</p>
                      </div>

                      <div className="col-12 col-md-4 mb-4">
                        <img src={ImageGlenAllenOffice} alt={'CapCenter HQ best mortgage home loan in North Carolina serviced by Virginia lending company low fee zero closing cost'} />
                      </div>

                      <div className="col-12 image-gallery">
                        <img src={ImageGlenAllenVA} alt={props.custom.title + " best mortgage home loan in North Carolina serviced by Virginia lender company low fee zero closing cost"} />
                        <img src={ImageRichmondRaceway} alt={props.custom.title + " RVA Richmond Raceway best mortgage home loan in North Carolina serviced by Virginia lender company low fee zero closing cost"} />
                        <img src={ImageGlenAllenVA2} alt={props.custom.title + " best mortgage home loan in North Carolina serviced by Virginia lender company low fee zero closing cost"} />
                        <img src={ImageGlenAllenVAPieDay} alt={props.custom.title + " RVA Richmond Glen Allen VA Pie Day 1 best mortgage home loan lender in North Carolina serviced by Virginia company low fee zero closing cost"} />
                        <img src={ImageGlenAllenVAPieDay2} alt={props.custom.title + " RVA Richmond Glen Allen VA Pie Day 2 best mortgage home lender in North Carolina serviced by Virginia company low fee zero closing cost"} />
                        <img src={ImageGlenAllenVAPieDay3} alt={props.custom.title + " RVA Richmond Glen Allen VA Pie Day 3 best mortgage home lender in North Carolina serviced by Virginia company low fee zero closing cost"} />
                        <img src={ImageGlenAllenVAPieDay4} alt={props.custom.title + " RVA Richmond Glen Allen VA Pie Day 4 best mortgage home lender in North Carolina serviced by Virginia company low fee zero closing cost"} />
                        <img src={ImageGlenAllenVAHalloweenTeam} alt={props.custom.title + " RVA Richmond Glen Allen VA in North Carolina serviced by Virginia Halloween Winning Team best mortgage home loan lender company in Virginia"} />
                        <img src={ImageGlenAllenVAHalloween} alt={props.custom.title + " Halloween best mortgage home loan lender company in North Carolina serviced by Virginia"} />
                        <img src={ImageSmores} alt={props.custom.title + " S'mores Day best mortgage home loan lender company in North Carolina serviced by Virginia low fee zero closing cost"} />
                        <img src={ImageSmores2} alt={props.custom.title + " S'mores Day best mortgage home loan lender company in North Carolina serviced by Virginia low fee zero closing cost"} />
                      </div>
                    </div>
                  </section>

                  <section className={(props.custom.code)}>
                    <div className="row">
                      <div className="col-12">
                        <img src={ImageCapCenterHQ} alt={props.custom.title + " best mortgage home loan in North Carolina serviced by Virginia lender high quality low fee zero closing costs"} width={'500px'}/>
                      </div>
                    </div>
                  </section>

                  <section className={(props.custom.code)}>
                    <div className="row">
                      <div className="col-12">
                        <h4>
                          <a href={`${baseRealEstateUrl}/homes/location/state/north-carolina`} target="_blank" rel="noreferrer noopener">
                          Homes for Sale in {props.custom.stateLongName}
                          </a>
                        </h4>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <ol>
                          {renderedHtmlListings}
                        </ol>
                      </div>
                    </div>
                  </section>

                </article>
              </main>
            </div>
          </>
        </AppWrapper>
      )}
    </React.Fragment>
  );
}

export default State;
